"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

interface PageviewTrackerProps {
  title: string;
}

export const PageviewTracker = ({ title }: PageviewTrackerProps) => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!pathname || !title) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Pageview",
      pagePath: pathname,
      pageTitle: title,
    });
  }, [pathname, title]);

  return null;
};
